import styled from 'styled-components';

import { DropdownHeaderTrigger } from 'components/Dropdown/HeaderTrigger/DropdownHeaderTrigger';
import { bodyMicroText, colors, transition } from 'theme/theme';

export const RsvpButtonMenuItem = styled.span`
  color: ${colors.lightContentGrey};
  padding: 5px 10px;
  ${bodyMicroText};
  transition: ${transition};
  user-select: none;
  width: 100%;
  display: flex;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;

export const RsvpDropdownHeaderTrigger = styled(DropdownHeaderTrigger)`
  font-size: 16px;
  gap: 8px;
  line-height: 20px;
`;
